export const LOCALSTORAGE_KEY = 'adminbase'
export const DEFAULT_FETCH_CUANTOS = 10

export const TIPO_NOTICIA_NORMAL = 'normal'

export const INFORMACION_PUBLICA_GRUPOS = [
	'Detalles CECTEC',
	'Constitución CECTEC',
	'Elección CECTEC',
	'Directiva CECTEC',
	'Reconocimiento CECTEC',
	'Rendición CECTEC',
]